// removed by extract-text-webpack-plugin
module.exports = {"articlesWrapper":"O2jKGs3fwjX55dX2gUoF6","article":"_2GPKqgUXqhhHE6QSmHOA92","picture":"_18sPZ1MfI9-N-8ZDHFTwzE","textPart":"_2fa04HdL5ZQVWI--sA8Ivm","textWrapper":"_2j6BD6tX28M3piWDQBhmIT","title":"PTHmy6oHluXDj9FXVf1jC","description":"_33QZH6DYBSY1XzLGZpWFOo","pageTitle":"_3MBclXACNXA88ew_pRCqoE","articlesBlock":"_49S8A5sBWrHDagFoFvDxS"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/ArticlesPage/ArticlesPage.scss
// module id = 1860
// module chunks = 0